<template>
    <div class="record min-height">
        <div class="flex align-center">
            <el-input placeholder="请输入机构名称/订单号" v-model="keyword" style="width: 350px;"></el-input>
            <el-button type="primary" class="margin-left-sm" @click="search">搜索</el-button>
        </div>
        <el-table
            :data="tableData"
            alig="center"
            border
            class="margin-top"
            header-row-class-name="table-header"
            row-class-name="table-row"
            style="width: 100%">
            <el-table-column label="序号" type="" width="80">
                <template slot-scope="scope">
                    {{ (page - 1) * 10 + scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column label="机构名称" prop="company_name"></el-table-column>
            <el-table-column label="订单号" prop="">
                <template slot-scope="scope">
                   {{scope.row.wx_order_num || '线下付款'}}
                </template>
            </el-table-column>
            <el-table-column label="缴费金额" prop="price"></el-table-column>
            <el-table-column label="缴费时间" prop="add_time"></el-table-column>
<!--            <el-table-column label="有效期开始时间" prop="start_time"></el-table-column>-->
<!--            <el-table-column label="有效期结束时间" prop="end_time"></el-table-column>-->
            <el-table-column label="发票状态">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.invoice_status === 0" class="font-size-sm margin-left-sm" type="text" disabled>待开立</el-button>
                    <el-link :underline="false" target="_blank"
                             :href="scope.row.invoice_url || (showhost + scope.row.invoice_img)"
                             v-else>
                        <el-button  class="font-size-sm margin-left-sm" type="text">
                            查看
                        </el-button>
                    </el-link>
                </template>
            </el-table-column>
        </el-table>
        <div class="flex align-center justify-between padding-top-sm">
            <span>共{{ total }}条数据</span>
            <el-pagination
                v-if="tableData.length > 0"
                :current-page.sync="page"
                :page-size="limit"
                :total="total"
                background
                layout="prev, pager, next, jumper"
                @current-change="getList"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {getOrderlist} from "@/api/admin";
import {SHOWHOST} from "@/config";

export default {
    name: "record",
    data() {
        return {
            keyword:'',
            tableData: [],
            page: 1,
            limit: 10,
            total: 0,
            drawer: false,
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        showhost() {
            return SHOWHOST
        },
    },
    created() {
        this.$emit("setIndex", this.$route.path, "缴费记录  / ", false, 'icon-shouji');
        this.getList()
    },
    components: {},
    methods: {
        //  获取列表
        async getList() {
            let _list = await getOrderlist(this.keyword,  this.page, this.limit)
            this.tableData = _list.data
            this.total = _list.total
        },
        search() {
            this.page = 1
            this.getList()
        }
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.record {
    background: #fff;
    padding: 30px;
    border-radius: 8px;

    .page-title {
        font-size: 20px;
        font-weight: bold;
        color: #667fa0;
    }
}

.pople-list {
    span {
        display: block;
        width: 80px;
        margin: 0 10px 10px 0;
        font-size: 14px;
    }
}
</style>